import { render, staticRenderFns } from "./RewardDetail.vue?vue&type=template&id=61e43c70&scoped=true"
import script from "./RewardDetail.vue?vue&type=script&lang=js"
export * from "./RewardDetail.vue?vue&type=script&lang=js"
import style0 from "./RewardDetail.vue?vue&type=style&index=0&id=61e43c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e43c70",
  null
  
)

export default component.exports